import { Typography, formatDate } from 'enable-ui';

import { type OnboardingResult } from 'modules/learners/core/type';
import { getOnboardingMaxScore, getOnboardingTotalScore } from 'modules/learners/utils';

import { ReactComponent as DownIcon } from 'assets/icons/collapse-down.svg';
import { ReactComponent as UpIcon } from 'assets/icons/up.svg';

interface Props {
  show: boolean;
  result: OnboardingResult;
}

export const CollapseHeader = ({ show, result }: Props) => {
  const headerStyles = {
    color: '#222',
    fontSize: 16,
    fontWeight: 400,
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: !show ? '1px solid rgba(0, 0, 0, 0.25)' : 'none',
        cursor: 'pointer',
        padding: '12px 0',
      }}
    >
      <div style={{ width: 48 }}>
        <div
          style={{
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 12,
            border: '1px solid rgba(0, 0, 0, 0.25)',
            backgroundColor: '#FFFDF7',
          }}
        >
          {show ? <UpIcon /> : <DownIcon />}
        </div>
      </div>
      <div style={{ flexGrow: 1, width: 0 }}>
        <Typography style={headerStyles}>{result.assessmentName}</Typography>
        <Typography
          style={{
            color: '#808080',
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '22px',
          }}
        >
          {result.answers.length} tests
        </Typography>
      </div>
      <Typography style={{ ...headerStyles, width: 171 }}>
        {getOnboardingTotalScore(result)} / {getOnboardingMaxScore(result)}
      </Typography>
      <Typography style={{ ...headerStyles, width: 190 }}>
        {formatDate(result.updatedAt, 'dd MMM yyyy, hh:mm a')}
      </Typography>
    </div>
  );
};
